import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import FileCopySharpIcon from '@mui/icons-material/FileCopySharp'
import FolderSharpIcon from '@mui/icons-material/FolderSharp'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import {Box, Grid, Tooltip} from '@mui/material'
import {Theme} from '@mui/material/styles'
import {PGButton, PGTypography} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

import {useMeStore} from '@progyny/store/meStore'

import {theme} from '@root/theme'

const useStyles = makeStyles()((theme: Theme) => ({
  removeIconContainer: {
    button: {
      borderRadius: 3,
      cursor: 'pointer',
    },
  },
  // Must sit on the element a Tooltip wraps: MUI anchors the tooltip to that
  // element's box, so an unconstrained inline span would push it off-screen.
  fileName: {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

type ExistingMemberIDProps = {
  setMemberIDRemoved: (value: boolean) => void
}

const ExistingMemberID: FC<ExistingMemberIDProps> = (props) => {
  const user = useMeStore((s) => s.user)
  const {classes} = useStyles()
  const {t} = useTranslation()
  const identityDocumentFileName = user?.member?.identityDocumentFileName
  const identityDocumentUrl = user?.member?.identityDocumentUrl
  const identityDocumentType = user?.member?.identityDocumentType

  const navigateToPreview = () => {
    window.open(identityDocumentUrl!, '_blank')
  }

  return (
    <>
      <Grid container spacing={3} mb={2} alignItems={'center'}>
        <Grid item xs={4}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'flex-start'}
            alignItems={'center'}
          >
            <Box mr={1}>
              <FolderSharpIcon sx={{color: '#B6BAC8'}} />
            </Box>
            <Box>
              <PGTypography variant={'caption'}>
                {identityDocumentType}
              </PGTypography>
            </Box>
          </Box>
        </Grid>
        <Grid
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'flex-start'}
          alignItems={'center'}
          sx={{cursor: 'pointer', minWidth: 0}}
          item
          xs={4}
          onClick={() => navigateToPreview()}
        >
          <Box mr={1} sx={{flexShrink: 0}}>
            <FileCopySharpIcon
              sx={{color: theme.palette.other.brandColors.primary}}
            />
          </Box>
          <Box sx={{minWidth: 0}}>
            <Tooltip title={identityDocumentFileName}>
              <span>
                <PGTypography
                  variant={'caption'}
                  className={classes.fileName}
                  data-testid={'file-name'}
                >
                  {identityDocumentFileName}
                </PGTypography>
              </span>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={4} sm={2} className={classes.removeIconContainer}>
        <Box>
          <Tooltip title={identityDocumentFileName}>
            <span>
              <PGButton
                variant={'outlined'}
                onClick={() => props.setMemberIDRemoved(true)}
                startIcon={<RemoveCircleOutlineIcon />}
                label={t('common_remove')}
                aria-label={identityDocumentFileName ?? undefined}
              />
            </span>
          </Tooltip>
        </Box>
      </Grid>
    </>
  )
}

export default ExistingMemberID
